import { FC, HtmlHTMLAttributes } from "react";

import styles from "./styles.module.scss";

type Props = {
    orientation?: "horizontal" | "vertical";
}

const Divider: FC<Props & HtmlHTMLAttributes<HTMLDivElement>> = ({
    className,
    orientation = "horizontal",
    ...props
}) => {
    return <div className={`${styles[orientation]} ${className}`} {...props} />;
};

export default Divider;
